// extracted by mini-css-extract-plugin
module.exports = {"Wallet":"Wallet_Wallet__oPZ_Q","content":"Wallet_content__1zrWL","logo":"Wallet_logo__1J7De","gif":"Wallet_gif__2rlCX","title":"Wallet_title__u_73K"};